export default function getCollectionEntries(type: string, collection: unknown) {
    if (type === "Object") {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const keys = Object.getOwnPropertyNames(collection as Record<string, unknown>);
        return keys.map((key) => ({
            key,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: (collection as Record<string, unknown>)[key],
        }));
    }

    return [];
}
